<ion-col class="flex-align-center">
    <ion-grid>
        <ion-row>
            <ion-col size="12" class="ion-text-center">
                <h3>Modelos de Permissões</h3>
                <p>Configurações de acesso para diferentes perfis de utilizadores</p>
            </ion-col>
        </ion-row>

        <ion-row *ngFor="let item of config?.ConfigList">
            <ion-col size="12">
                <ion-card>
                    <ion-card-header>
                        <ion-card-title>
                            {{ item?.Name }}
                            <ion-badge [color]="getRoleColor(item?.UserRole?.Id)">
                                {{ item?.UserRole?.Name }}
                            </ion-badge>
                            <ion-badge *ngIf="item?.IsMain" color="primary">Principal</ion-badge>
                            <ion-badge *ngIf="item?.IsPublic" color="success">Público</ion-badge>
                        </ion-card-title>
                        <ion-card-subtitle *ngIf="item?.Description">
                            {{ item?.Description | slice:0:100 }}{{ item?.Description.length > 100 ? '...' : '' }}
                        </ion-card-subtitle>
                    </ion-card-header>

                    <ion-card-content>
                        <!-- Informações Básicas -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="information-circle-outline" slot="start"></ion-icon>
                                    <ion-label><strong>ID:</strong> {{ item?.Id }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="calendar-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Criado em:</strong> {{ item?.CreateDate | date:'medium'
                                        }}</ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="person-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Criado por:</strong> {{ item?.CreateUser }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row *ngIf="item?.UpdateDate">
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="calendar-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Atualizado em:</strong> {{ item?.UpdateDate | date:'medium'
                                        }}</ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="person-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Atualizado por:</strong> {{ item?.UpdateUser }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Papel do Utilizador -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item-divider>
                                    <ion-label>Papel do Utilizador</ion-label>
                                </ion-item-divider>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="people-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Perfil:</strong> {{ item?.UserRole?.Name }}</ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="id-card-outline" slot="start"></ion-icon>
                                    <ion-label><strong>ID do Perfil:</strong> {{ item?.UserRole?.Id }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Descrição Completa -->
                        <ion-row *ngIf="item?.Description">
                            <ion-col size="12">
                                <ion-item-divider>
                                    <ion-label>Descrição</ion-label>
                                </ion-item-divider>
                            </ion-col>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="document-text-outline" slot="start"></ion-icon>
                                    <ion-label>
                                        <div class="description-content">{{ item?.Description }}</div>
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Configurações de Visibilidade -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item-divider>
                                    <ion-label>Configurações de Visibilidade</ion-label>
                                </ion-item-divider>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon
                                        [name]="item?.IsMain ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                        slot="start"></ion-icon>
                                    <ion-label><strong>Perfil Principal:</strong> {{ item?.IsMain ? 'Sim' : 'Não'
                                        }}</ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon
                                        [name]="item?.IsPublic ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                        slot="start"></ion-icon>
                                    <ion-label><strong>Perfil Público:</strong> {{ item?.IsPublic ? 'Sim' : 'Não'
                                        }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Ações (exemplo) -->
                        <!--
                        <ion-row>
                            <ion-col size="12">
                                <ion-item-divider>
                                    <ion-label>Ações</ion-label>
                                </ion-item-divider>
                            </ion-col>
                        </ion-row>

                         <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="construct-outline" slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>Permissões Associadas:</strong>
                                        <div class="permissions-container">
                                            <ion-chip color="primary">
                                                <ion-icon name="create-outline"></ion-icon>
                                                <ion-label>Editar</ion-label>
                                            </ion-chip>
                                            <ion-chip color="secondary">
                                                <ion-icon name="eye-outline"></ion-icon>
                                                <ion-label>Visualizar</ion-label>
                                            </ion-chip>
                                            <ion-chip color="tertiary">
                                                <ion-icon name="trash-outline"></ion-icon>
                                                <ion-label>Eliminar</ion-label>
                                            </ion-chip>
                                            <ion-chip color="success">
                                                <ion-icon name="checkmark-outline"></ion-icon>
                                                <ion-label>Aprovar</ion-label>
                                            </ion-chip>
                                        </div>
                                        <p class="permissions-note">Nota: Estas são permissões genéricas. As permissões
                                            reais dependem da configuração específica do sistema.</p>
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row> -->
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-col>